import kyWithSentry from './helper/kyWithSentry';

import getShortFormVideoActualityUrl from 'url-constructors/ShortFormVideo/getShortFormVideoActualityUrl';

const shortFormVideoTrendInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData?: any
): Promise<Response> => {
  try {
    const actualityFetch = async (): Promise<any> =>
      kyWithSentry.get(getShortFormVideoActualityUrl(interceptionData)).json();
    const actualityPromise = actualityFetch();
    const actualityData = await actualityPromise;
    const lastAvailableDate =
      actualityData &&
      Array.isArray(actualityData) &&
      actualityData?.length > 0 &&
      actualityData.reduce((acc, item) =>
        (item.data[0]?.actualDate > acc) ? item.data[0]?.actualDate : acc,
        actualityData[0].data[0]?.actualDate);

    return new Response(
      JSON.stringify({
        actualityData: lastAvailableDate,
      })
    );
  } catch (error) {
    const errorInfo = await error.response.json();
    return new Response(
      JSON.stringify({
        reason: {
          error: errorInfo.message,
          errorInfo,
        },
      })
    );
  }
};

export default shortFormVideoTrendInterceptor;
